import { AlertTriangle, ShieldCheck } from "lucide-react";
import { CaseloadEditor } from "@/components/supervision/PairingForm";
import { MonthStatusCard, PendingEntries } from "@/components/supervision/AssistantWorkspace";
import { EntryList, SupervisionEntryForm } from "@/components/supervision/SupervisionEntryForm";

export function SupervisorWorkspace({ pairing, overview, onReload }) {
  const dueSoon = pairing.caseload.filter((c) => c.next_due && (c.overdue || c.days_until_due <= 5));

  return (
    <div className="supervision-workspace" data-testid={`supervisor-workspace-${pairing.id}`}>
      <div className="supervision-pair-names">
        <strong>You supervise {pairing.assistant_name}</strong>
        <span className="pairing-meta">{pairing.jurisdiction} {pairing.discipline} · since {pairing.start_date}{pairing.first_90_days_active ? ` · first 90 days until ${pairing.first_90_days_end}` : ""} · backup {pairing.backup_supervisor_name || "not named"}</span>
        {pairing.activation_status !== "Active" && <span className="status-chip status-pending" data-testid={`workspace-status-${pairing.id}`}>{pairing.activation_status}</span>}
        {pairing.backup_warning && <span className="status-chip status-pending backup-warning-chip" data-testid={`workspace-backup-warning-${pairing.id}`}><AlertTriangle size={11} /> {pairing.backup_warning}</span>}
      </div>
      {dueSoon.length > 0 && (
        <p className="pairing-warnings-inline" data-testid={`caseload-alerts-${pairing.id}`}><AlertTriangle size={13} /> Client supervision due: {dueSoon.map((c) => `${c.initials} (${c.overdue ? "overdue" : `in ${c.days_until_due}d`})`).join(", ")}</p>
      )}
      <div className="supervision-month-grid">
        {pairing.months.map((month) => <MonthStatusCard key={month.month} row={month} role="supervisor" />)}
      </div>
      <PendingEntries pairing={pairing} role="supervisor" onReload={onReload} />
      {pairing.activation_status === "Active" && <SupervisionEntryForm pairing={pairing} overview={overview} role="supervisor" onSaved={onReload} />}
      <EntryList pairing={pairing} role="supervisor" />
      <details className="supervision-history">
        <summary><ShieldCheck size={13} /> Caseload & per-client due dates ({pairing.caseload.length})</summary>
        <CaseloadEditor pairing={pairing} canEdit={pairing.activation_status === "Active"} onSaved={() => onReload()} />
      </details>
    </div>
  );
}
